
export const env = __DEV__ ? 'development' : 'production';
